import { render } from "./GivingForm4.vue?vue&type=template&id=f0f1956a&scoped=true"
import script from "./GivingForm4.vue?vue&type=script&lang=js"
export * from "./GivingForm4.vue?vue&type=script&lang=js"

import "./GivingForm4.vue?vue&type=style&index=0&id=f0f1956a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0f1956a"]])

export default __exports__